import {
  type MutationFunction,
  type QueryKey,
  useMutation,
  type UseMutationResult,
  useQueryClient,
} from "@tanstack/react-query";

import { useErrorSnackbar, useSuccessSnackbar } from "../../Components/SharedSnackbar/SharedSnackbar.context";
import { consoleErrorWithSentry } from "../../utils";

export const useApiMutation = <TData, TVariables>({
  mutationFn,
  queryKeyToInvalidate,
  successMessage,
  errorMessage,
}: {
  mutationFn: MutationFunction<TData, TVariables>;
  queryKeyToInvalidate: QueryKey;
  successMessage?: string;
  errorMessage: string;
}): UseMutationResult<TData, Error, TVariables> => {
  const queryClient = useQueryClient();
  const successSnackbar = useSuccessSnackbar();
  const errorSnackbar = useErrorSnackbar();

  return useMutation<TData, Error, TVariables>({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeyToInvalidate });
      if (successMessage) {
        successSnackbar(successMessage);
      }
    },
    onError: (e) => {
      consoleErrorWithSentry(e);
      errorSnackbar(errorMessage);
    },
  });
};
